import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/utils/AuthContext';
import { TooltipProvider } from '@/components/ui/tooltip';
import { LanguageProvider } from '@/i18n/LanguageContext';
import App from './App';
import { hydratePhRef } from '@/utils/phRef';
import '@/i18n';
import './index.css';

// PartnerHub ref_code bootstrap.
// 1) Hydrate from shared cookie on .create-products.com — covers bypass scenarios
//    (bookmark, logged-in session in another tab, landing CTA skipped).
// 2) URL param overwrites — a fresh referral click should replace stale values.
hydratePhRef();

const params = new URLSearchParams(window.location.search);
const phRef = params.get('ph_ref');
if (phRef) {
  localStorage.setItem('ph_ref', phRef);
  // Clean URL
  params.delete('ph_ref');
  const newUrl = params.toString()
    ? `${window.location.pathname}?${params}`
    : window.location.pathname;
  window.history.replaceState({}, '', newUrl);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <TooltipProvider>
            <App />
            <Toaster position="top-right" richColors />
          </TooltipProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  </StrictMode>
);
